export default __webpack_public_path__ + "static/media/ok.548b7be6.svg";